module.exports = __webpack_public_path__ + "img/aboveHead.6b5cdf8d.svg";